// React
import React from 'react';
// Material-UI
import { Link } from '@material-ui/core';
// Otras libs

// Componentes

// Funciones

// Hooks


/**
 *
 * @typedef {Object} Props
 * @property {string} label Etiqueta de botón
 * @property {() => void} onClick Evento al presionar botón
 */

/**
 * Botón
 * @param {Props} props
 * @param {ChildrenFn} props.children
 * @returns
 */
export const BotonLink = ({ 
    label = '',
    onClick = () => {},
}) => {
    // Idioma

    // Estados
    

    // Vista
    return (
        <Link 
            component="button"
            variant="body2" 
            onClick={(ev) => {
                ev.preventDefault();
                onClick();
            }}
        >
            {label}
        </Link>
    );
};
